import { useState } from 'react';
import { Trans } from '@lingui/react/macro';
import { t } from '@lingui/core/macro';
import { getConfigItem, lockOut } from 'util/device';
import useDevicesStore from 'store/devices';
import { useNotificationsStore } from '@thermon-platforms/thermon-ui-core';

function Button({device, disabled}) {
  const [, notificationsStoreActions] = useNotificationsStore();
  const [, devicesStoreActions] = useDevicesStore();
  const [processing, setProcessing] = useState(false);
  const LOTO = getConfigItem(device.model, 'LockoutTagOut');

  function doLockOut() {
    setProcessing(true);
    lockOut(device.model, (res) => {
      setProcessing(false);
      if (res == 'cancelled') return;
      if (!res?.ok) {
        notificationsStoreActions.notify(
          t`This device couldn't be locked out. Check your configuration for errors.`,
          'alert'
        );
        return;
      }
      devicesStoreActions.forceUpdate();
    })
  }

  return (
    <button
      className={`lock-out ${LOTO?.value == 'on' ? 'active' : ''} ${processing ? 'processing' : ''}`}
      data-tooltip-content={t`Lock Out / Tag Out`}
      data-tooltip-id="control-tooltip"
      disabled={processing || disabled}
      onClick={doLockOut}
    >
      <Trans>Lock Out / Tag Out</Trans>
    </button>
  )
}

export default Button;
